
webpack.register(
    'components/timeline/card-options/card-options',
    function() {
        return require('components/timeline/card-options/card-options');
    },
    false
);
webpack.register(
    'components/card/trending/trending',
    function() {
        return require('components/card/trending/trending');
    },
    false
);
webpack.register(
    'components/card/external-link/external-link',
    function() {
        return require('components/card/external-link/external-link');
    },
    false
);
webpack.register(
    'components/card/article/article',
    function() {
        return require('components/card/article/article');
    },
    false
);
webpack.register(
    'components/card/info/info',
    function() {
        return require('components/card/info/info');
    },
    false
);
webpack.register(
    'components/card/photo/photo',
    function() {
        return require('components/card/photo/photo');
    },
    false
);
webpack.register(
    'components/card/social/social',
    function() {
        return require('components/card/social/social');
    },
    false
);
webpack.register(
    'components/card/video/video',
    function() {
        return require('components/card/video/video');
    },
    false
);
webpack.register(
    'components/card/department/department',
    function() {
        return require('components/card/department/department');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/timeline/card-options/card-options\"/>\r\n\r\n<can-import from=\"components/card/trending/trending\"/>\r\n<can-import from=\"components/card/external-link/external-link\"/>\r\n<can-import from=\"components/card/article/article\"/>\r\n<can-import from=\"components/card/info/info\"/>\r\n<can-import from=\"components/card/photo/photo\"/>\r\n<can-import from=\"components/card/social/social\"/>\r\n<can-import from=\"components/card/video/video\"/>\r\n<can-import from=\"components/card/department/department\"/>\r\n\r\n{{#in timelineType 'department'}}\r\n    <card-department card-index=\"{{cardIndex}}\"></card-department>\r\n{{else}}\r\n    {{#switch type}}\r\n\r\n        {{#case \"trendingCard\"}}\r\n            <card-trending {^closed}=\"closed\" card-index=\"{{cardIndex}}\"></card-trending>\r\n        {{/case}}\r\n\r\n        {{#case \"linkCard\"}}\r\n            <card-external-link timeline-type=\"{{timelineType}}\" card-index=\"{{cardIndex}}\"></card-external-link>\r\n        {{/case}}\r\n\r\n        {{#case \"infoCard\"}}\r\n            <card-info card-index=\"{{cardIndex}}\"></card-info>\r\n        {{/case}}\r\n\r\n        {{#case \"articleCard\"}}\r\n            <card-article timeline-type=\"{{timelineType}}\" card-index=\"{{cardIndex}}\"></card-article>\r\n        {{/case}}\r\n\r\n        {{#case \"photoCard\"}}\r\n            <card-photo timeline-type=\"{{timelineType}}\" card-index=\"{{cardIndex}}\"></card-photo>\r\n        {{/case}}\r\n\r\n        {{#case \"socialCard\"}}\r\n            <card-social card-index=\"{{cardIndex}}\"></card-social>\r\n        {{/case}}\r\n\r\n        {{#case \"videoCard\"}}\r\n            <card-video timeline-type=\"{{timelineType}}\" {card}=\"card\" {(active-card)}=\"activeCard\" card-index=\"{{cardIndex}}\"></card-video>\r\n        {{/case}}\r\n\r\n        {{#case \"GSVideoCard\"}}\r\n             <card-video timeline-type=\"{{timelineType}}\" {card}=\"card\" {(active-card)}=\"activeCard\" card-index=\"{{cardIndex}}\"></card-video>\r\n        {{/case}}\r\n\r\n        {{#case \"GSArticleCard\"}}\r\n             <card-article\r\n              timeline-type=\"{{timelineType}}\"\r\n              card-index=\"{{cardIndex}}\"\r\n                {{#if fromtimeline}}\r\n                    {fromtimeline}=\"true\"\r\n                {{else}}\r\n                    {fromtimeline}=\"false\"\r\n                {{/if}}\r\n                ></card-article>\r\n        {{/case}}\r\n\r\n        {{#case \"GSPhotoCard\"}}\r\n            <card-photo timeline-type=\"{{timelineType}}\" card-index=\"{{cardIndex}}\"></card-photo>\r\n        {{/case}}\r\n\r\n    {{/switch}}\r\n{{/in}}\r\n");